module.exports = __webpack_public_path__ + "img/CRC2_Fibroblasts.07b225ac.png";